export default [
    {
        path: '/report/employee-daily-timescans',
        name: 'report-employee-daily-timescan',
        meta: { requiresAuth: true },
        component: () => import('@/pages/report/employee/employee-daily-timescan.vue')
    }
]
